import DOMPurify from 'dompurify'
import React from 'react'
import { Container, Label, Value, ValueHTML } from './styles'

interface ModalLongInformationsoProps {
  label?: string
  value?: string
  valueHTML?: string
}

const ModalLongInformations: React.FC<ModalLongInformationsoProps> = ({
  label,
  valueHTML,
  value
}: ModalLongInformationsoProps): JSX.Element => {
  function formatText(text) {
    if (text === text.toUpperCase() && text !== text.toLowerCase()) {
      return <b data-testid="bold">{text}</b>
    }
    return text
  }
  return (
    <Container>
      {label && <Label>{`${label}: `}</Label>}
      {valueHTML && (
        <ValueHTML data-testid="value_html" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(valueHTML) }} />
      )}
      {value && <Value data-testid="value_string">{formatText(value)}</Value>}
      <br />
    </Container>
  )
}
export { ModalLongInformations }
